import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const bodyFatCalculatorTool: Tool = {
  id: "body-fat-calculator",
  name: () => m.bf_tool_name(),
  description: () => m.bf_tool_description(),
  icon: "📉",
  basePath: "/body-fat-calculator",
  status: "stable",
  tags: ["health", "fitness", "calculator", "body-fat-calculator"],
};
